export const DATASET_RECEIPTS_STORAGE_KEY = 'fesmelacta.datasetReceipts.v1';

export function getDatasetReceipts() {
  try {
    const receipts = JSON.parse(localStorage.getItem(DATASET_RECEIPTS_STORAGE_KEY) || '[]');
    return Array.isArray(receipts) ? receipts : [];
  } catch (error) {
    return [];
  }
}

export function saveDatasetReceipt(receipt) {
  const safe = { submissionId: receipt.submissionId, token: receipt.token, createdAt: receipt.createdAt };
  const receipts = getDatasetReceipts().filter((item) => item.submissionId !== safe.submissionId);
  localStorage.setItem(DATASET_RECEIPTS_STORAGE_KEY, JSON.stringify([safe, ...receipts]));
  return safe;
}

export function removeDatasetReceipt(submissionId) {
  localStorage.setItem(DATASET_RECEIPTS_STORAGE_KEY, JSON.stringify(
    getDatasetReceipts().filter((item) => item.submissionId !== submissionId),
  ));
}
